import { useState } from "react";
import { Reveal, Overline } from "./Reveal";
import { useSettings, imgSrc } from "@/lib/settings";

export default function Gallery() {
  const [filter, setFilter] = useState("Tout");
  const { settings } = useSettings();
  const images = settings.gallery || [];
  const filters = ["Tout", ...new Set(images.map((i) => i.tag))];
  const visible = filter === "Tout" ? images : images.filter((i) => i.tag === filter);

  return (
    <section id="galerie" className="mx-auto max-w-7xl px-6 py-28 lg:px-12 lg:py-40" data-testid="gallery-section">
      <Reveal className="flex flex-wrap items-end justify-between gap-8">
        <div>
          <Overline className="mb-6">Galerie</Overline>
          <h2 className="font-display max-w-xl text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[var(--brand-dark)]">
            Nos réalisations, <span className="italic font-light text-[var(--brand-accent)]">en images.</span>
          </h2>
        </div>
        <p className="max-w-xs text-sm font-light leading-relaxed text-[var(--brand-muted)]">
          Un aperçu du travail de l'institut — chaque cliente repart avec une signature unique.
        </p>
      </Reveal>

      <Reveal className="mt-12 flex flex-wrap gap-3" data-testid="gallery-filters">
        {filters.map((f) => (
          <button key={f} onClick={() => setFilter(f)}
                  className={`rounded-full border px-6 py-2.5 text-[11px] uppercase tracking-[0.2em] transition-colors duration-300 ${
                    filter === f ? "border-[var(--brand-dark)] bg-[var(--brand-dark)] text-[var(--brand-bg)]" : "border-black/15 text-[var(--brand-dark)] hover:border-[var(--brand-accent)] hover:text-[var(--brand-accent)]"
                  }`}
                  data-testid={`gallery-filter-${f.toLowerCase()}`}>
            {f}
          </button>
        ))}
      </Reveal>

      <div className="mt-12 columns-2 gap-5 space-y-5 md:columns-3 lg:columns-4" data-testid="gallery-grid">
        {visible.map((img, i) => (
          <Reveal key={img.src} delay={(i % 4) * 0.06} className="break-inside-avoid">
            <figure className="group relative overflow-hidden">
              <img src={imgSrc(img.src)} alt={img.alt} data-testid={`gallery-img-${i}`}
                   className="w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[var(--brand-dark)]/70 to-transparent p-5 text-xs uppercase tracking-[0.25em] text-[var(--brand-bg)] opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                {img.tag}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
